import { render, staticRenderFns } from "./ContentSectionComponent.vue?vue&type=template&id=55ff7125&scoped=true"
import script from "./ContentSectionComponent.vue?vue&type=script&lang=js"
export * from "./ContentSectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentSectionComponent.vue?vue&type=style&index=0&id=55ff7125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff7125",
  null
  
)

export default component.exports